import { ICellCss, IRow } from "./../types";

export function rgbToHex(color: string): string {
	if (color.substr(0, 1) === "#") {
		return color;
	}
	const digits = /(.*?)rgb[a]?\((\d+), *(\d+), *(\d+),* *([\d]*)\)/.exec(color);

	const red = parseInt(digits[2], 10).toString(16);
	const green = parseInt(digits[3], 10).toString(16);
	const blue = parseInt(digits[4], 10).toString(16);

	return `#${red}${green}${blue}`;
}

export function transpose(arr: any[][], transform?: any): any[][] {
	const columns = [];
	for (let i = 0;i < arr.length;i++) {
		const row = arr[i];
		for (let cellInd = 0;cellInd < row.length;cellInd++) {
			columns[cellInd] = columns[cellInd] || [];
			const cell = transform ? transform(row[cellInd]) : row[cellInd];
			columns[cellInd].push(cell);
		}
	}
	return columns;
}

export function getStrWidth(str: string, font: string = "14px Arial") {
	const canvas = document.createElement("canvas");
	const ctx = canvas.getContext("2d");
	ctx.font = font;
	return Math.round(ctx.measureText(str).width);
}

function insert(node: HTMLElement, newone: string | HTMLElement): HTMLElement {
	if (typeof newone === "string") {
		node.insertAdjacentHTML("beforeend", newone);
		return node.lastChild as HTMLElement;
	} else {
		node.appendChild(newone);
		return newone;
	}
}
export function getStyleByClass(cssClass: string, container: HTMLElement, targetClass: string, def?: ICellCss): ICellCss {
	const cont = container.querySelector("." + targetClass) as HTMLElement;

	const testDiv = insert(cont, `<div class="${cssClass}"></div>`);
	const styles = window.getComputedStyle(testDiv as HTMLElement);
	const result = {
		color: styles.color === "rgb(0, 0, 0)" ? def.color : rgbToHex(styles.color),
		background: styles.backgroundColor === "rgba(0, 0, 0, 0)" ? def.background : rgbToHex(styles.backgroundColor),
		fontSize: parseFloat(styles.fontSize)
	};
	cont.removeChild(testDiv);
	// [dirty]
	if (result.color === def.color
		&& result.background === def.background
		&& result.fontSize === def.fontSize) {
		return null;
	}
	return result;
}
export function removeHTMLTags(str: string): string {
	if (typeof str !== "string" && typeof str !== "number" && typeof str !== "boolean") {
		return "";
	}
	return `${(str === undefined || str === null) ? "" : str}`.replace(/<[^>]*>/g, "").replace(/[\"]/g, "&quot;").trim();
}
export function isCssSupport(property: string, value: string): boolean {
	try {
		return CSS.supports(property, value);
	} catch (err) {
		const el = document.createElement("div");
		el.style[property] = value;
		return el.style[property] === value;
	}
}

export function isRowEmpty(row: IRow): boolean {
	if (!row) {
		return;
	}
	return Object.keys(row).reduce((acc, col) => {
		if (col === "id" || col[0] === "$") {
			return acc;
		}
		if (acc && (row[col] !== undefined && row[col] !== "")) {
			return false;
		}
		return acc;
	}, true);
}